module.exports = __webpack_public_path__ + "media/images/font/Gustavo-MediumItalic-18e654313af242f79c0edc6857cd063f.eot";